<template>
    <v-container>
      <v-row>
        <v-col>
          <v-card class="d-flex align-center justify-center flex-column pa-5">
            <v-card-title class="text-h6 font-weight-bold">
              Notes & Comments
            </v-card-title>
  
            <!-- Comment Input Section -->
            <v-textarea
              v-model="newComment"
              label="Add a comment..."
              auto-grow
              outlined
              dense
              class="mt-3"
            ></v-textarea>
  
            <v-btn 
              color="primary"
              :disabled="!newComment"
              @click="addComment"
              class="mt-2">
              Add Comment
            </v-btn>
  
            <!-- Notes List -->
            <v-list class="mt-4 w-100">
              <v-list-item-group>
                <v-list-item v-for="(note, index) in notes" :key="index" class="my-2">
                  <v-list-item-icon>
                    <v-avatar color="#def6ff" size="30" class="icon-box">
                      <v-icon small color="#00B3FF">mdi-comment</v-icon>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <strong>{{ note.user }}</strong>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ note.date }} | {{ note.time }}
                    </v-list-item-subtitle>
                    <p class="mt-2">{{ note.comment }}</p>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="border-opacity-25"></v-divider>
              </v-list-item-group>
            </v-list>
            
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    name: "Notes",
    data() {
      return {
        newComment: "",
        notes: [
          { user: "John Doe", date: "2025-02-07", time: "10:30 AM", comment: "Reviewed the purchase order details." },
          { user: "Alice Smith", date: "2025-02-06", time: "3:45 PM", comment: "Waiting for approval on the last update." }
        ],
      };
    },
    methods: {
      addComment() {
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split("T")[0];
        const formattedTime = currentDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  
        this.notes.unshift({
          user: "Current User",  // Replace with actual user data if available
          date: formattedDate,
          time: formattedTime,
          comment: this.newComment
        });
  
        this.newComment = "";
      }
    }
  };
  </script>
  
  <style scoped>
  .v-list-item {
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 10px;
  }
  </style>
  